export const AGENT_PROVIDERS = ['anthropic', 'openai', 'bedrock_anthropic', 'bedrock_openai'];
export const DEFAULT_PROVIDER = 'anthropic';
